import * as React from 'react'

const SvgAudioIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.975 4.05l-.956.806a6.25 6.25 0 01-.181 8.27l.918.874a7.5 7.5 0 00.219-9.925V4.05zM12.488 6.5a3.75 3.75 0 01-.113 4.963l.919.85a5 5 0 00.143-6.62l-.95.807zM10.25 17.75a.625.625 0 01-.444-.187L5.044 12.75H.875a.625.625 0 01-.625-.625v-6.25c0-.345.28-.625.625-.625h4.169L9.806.438a.625.625 0 01.882 0 .625.625 0 01.187.437v16.25c0 .345-.28.625-.625.625zM1.5 11.5h3.8c.167 0 .327.068.444.188l3.881 3.918V2.394L5.744 6.313A.625.625 0 015.3 6.5H1.5v5z"
      fill="#163250"
    />
  </svg>
)

export default SvgAudioIcon
